import {
  LOGGER_DAILY_ITEMS_LAST_RESET_KEY,
  LOGGER_DAILY_ITEMS_COUNTER_KEY,
} from './LocalStorage/localStorageKeys';
import { reportToRollbar } from './Logger';

export const MAX_DAILY_ROLLBAR_ITEMS = 100;

const resetDailyMaxItems = () => {
  localStorage.setItem(
    LOGGER_DAILY_ITEMS_LAST_RESET_KEY,
    new Date().toISOString()
  );
  localStorage.setItem(LOGGER_DAILY_ITEMS_COUNTER_KEY, '0');
};

export const needsTimeReset = (
  now: Date,
  lastResetString: string | null
): boolean => {
  if (lastResetString == null) {
    return true;
  }

  const lastReset = new Date(lastResetString);

  const nextReset = new Date(lastReset.getTime());
  nextReset.setHours(nextReset.getHours() + 24);
  if (nextReset < now) {
    return true;
  }

  return false;
};

export const hasExceededDailyMaxItemsAndReset = (
  now: Date,
  lastResetString: string | null,
  itemsCounter: number
): boolean => {
  if (needsTimeReset(now, lastResetString)) {
    resetDailyMaxItems();
    return false;
  }

  if (itemsCounter > MAX_DAILY_ROLLBAR_ITEMS) {
    if (itemsCounter === MAX_DAILY_ROLLBAR_ITEMS + 1 && reportToRollbar()) {
      (window as any).Rollbar.critical(
        Error('Has exceeded max number of daily rollbar items')
      );
    }
    return true;
  }

  return false;
};

export const hasExceededDailyMaxItems = (): boolean => {
  const lastResetString = localStorage.getItem(
    LOGGER_DAILY_ITEMS_LAST_RESET_KEY
  );
  const itemsCounter = Number.parseInt(
    localStorage.getItem(LOGGER_DAILY_ITEMS_COUNTER_KEY) || '0',
    10
  );

  return hasExceededDailyMaxItemsAndReset(
    new Date(),
    lastResetString,
    itemsCounter
  );
};

export const increaseDailyItemsCounter = () => {
  const itemsCounter = Number.parseInt(
    localStorage.getItem(LOGGER_DAILY_ITEMS_COUNTER_KEY) || '0',
    10
  );

  localStorage.setItem(
    LOGGER_DAILY_ITEMS_COUNTER_KEY,
    (itemsCounter + 1).toString()
  );
};
